import { Dialog } from '@headlessui/react'
import type { Dispatch, SetStateAction } from 'react'

import EditFilterIcon from '../../../../assets/images/icons/filter-save-icon.svg?react'
import XIcon from '../../../../assets/images/icons/x-close-filter.svg?react'

type Props = {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  filterName?: string
  hasModified: boolean
  isLoading: boolean
  onUpdate: () => void
  onSaveNew: () => void
}

export default function FilterSaveChoiceModal({
  isOpen,
  setIsOpen,
  filterName,
  hasModified,
  isLoading,
  onUpdate,
  onSaveNew,
}: Props) {
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="relative z-50"
    >
      <div
        className="fixed inset-0 flex items-center justify-center p-4"
        style={{
          background: 'rgba(41, 41, 41, 0.7)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <Dialog.Panel className="relative border rounded-xl shadow-xl bg-white-100">
          <div className="flex flex-col p-6 w-96">
            <div className="flex flex-col items-center">
              <div className="flex flex-row justify-center w-full">
                <EditFilterIcon />
                <button
                  type="button"
                  className="absolute right-8 border-0 rounded-full p-2 active:bg-gray-100"
                  onClick={() => setIsOpen(false)}
                >
                  <XIcon />
                </button>
              </div>

              <h1 className="font-medium text-lg text-gray-900 pt-5 pb-2">
                Save filter
              </h1>
              <p className="font-normal text-sm text-gray-500 text-center pb-5">
                Would you like to update the existing filter
                {filterName ? (
                  <>
                    {' '}
                    <span className="font-medium text-gray-700">
                      "{filterName}"
                    </span>
                  </>
                ) : null}
                , or save it as a new filter?
              </p>

              <div className="flex flex-col w-full gap-3">
                <button
                  type="button"
                  disabled={!hasModified || isLoading}
                  onClick={() => {
                    setIsOpen(false)
                    onUpdate()
                  }}
                  className="h-11 w-full flex justify-center items-center bg-primary-600 border border-solid border-primary-600 rounded-lg active:bg-primary-700 disabled:opacity-40"
                >
                  <span className="font-medium text-base text-white-100">
                    Update existing filter
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsOpen(false)
                    onSaveNew()
                  }}
                  className="h-11 w-full flex justify-center items-center border border-solid border-gray-300 rounded-lg active:bg-gray-100"
                >
                  <span className="font-medium text-base text-gray-700">
                    Save as new filter
                  </span>
                </button>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}
